// SandboxPage.jsx
import React, { useState, useEffect } from "react";
import { PDFViewer } from "@react-pdf/renderer";
import DocumentStructure from "./components/DocumentStructure";
import { calculateTableData } from "./calculations";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { SET_NEW_FILTERS, SET_FILTERED_DATA } from "constants/actions";
import Anchor from "app/audit/simple/Anchor";
import Filters from "app/audit/simple/Filters";

const SandboxPage = () => {
  const dispatch = useDispatch();
  const [calculated, setCalculated] = useState(null);
  const [prevDataCalculated, setPrevDataCalculated] = useState(null);
  const [anchorLabel, setAnchorLabel] = useState(null);
  const [selectedFactor, setSelectedFactor] = useState(null);
  const rule = 2;
  const raw_data = useSelector((state) => state.audit?.raw_data, shallowEqual);
  const anchor = useSelector((state) => state.audit?.anchor, shallowEqual);
  const core_data = useSelector(
    (state) => state.audit?.core_data,
    shallowEqual
  );

  const selectedFilters = useSelector(
    (state) => state.audit?.new_filters,
    shallowEqual
  );

  const filtered_data = useSelector(
    (state) => state.audit?.filtered_data,
    shallowEqual
  );

  const filter_last_data = useSelector(
    (state) => state.audit?.filtered_last_data,
    shallowEqual
  );

  const get_organization = useSelector(
    (state) => state.organizations,
    shallowEqual
  );

  useEffect(() => {
    return () => {
      dispatch({
        type: SET_NEW_FILTERS,
        payload: [],
      });
      dispatch({
        type: SET_FILTERED_DATA,
        payload: raw_data,
      });
    };
  }, [raw_data]);

  useEffect(() => {
    setTimeout(() => {
      setCalculated(null);
    }, 1000);
  }, [anchor, selectedFilters]);

  useEffect(() => {
    if (
      filtered_data &&
      filtered_data.length > 0 &&
      filtered_data?.[0]?.responses &&
      filtered_data?.[0]?.responses.length > 0 &&
      core_data &&
      rule &&
      selectedFilters &&
      !calculated &&
      anchor
    ) {
      setCalculated(
        calculateTableData(
          filtered_data?.[0]?.responses,
          selectedFilters,
          core_data?.categories?.[0],
          anchor,
          3,
          core_data?.questions,
          core_data?.outcomeQuestions,
          core_data?.standards?.response
        )
      );

      if (filter_last_data && filter_last_data.length > 0) {
        setPrevDataCalculated(
          calculateTableData(
            filter_last_data,
            selectedFilters,
            core_data?.categories?.[0],
            anchor,
            3,
            core_data?.questions,
            core_data?.outcomeQuestions
          )
        );
      }
    }
  }, [
    filtered_data,
    core_data,
    rule,
    anchor,
    selectedFilters,
    filter_last_data,
    calculated,
  ]);

  useEffect(() => {
    if (core_data) {
      let item = core_data.questions.dimensions[0].factors[0];
      item["dimension"] = 0;
      setSelectedFactor(item);
    }
  }, [core_data]);

  useEffect(() => {
    if (anchor && core_data?.categories?.[0]) {
      // Find the anchor in the core data
      let anchorData = core_data.categories[0].categories.find(
        (dimension) => dimension.id === anchor
      );
      setAnchorLabel(anchorData?.name);
    }
  }, [anchor]);

  return (
    <div style={styles.container}>
      <Anchor anchorLabel=" " />
      <Filters />
      {calculated && (
        <>
          <h1 style={styles.heading}>PDF Sandbox</h1>
          <PDFViewer style={styles.viewer}>
            <DocumentStructure
              anchor={anchorLabel}
              orgData={get_organization}
              calculatedData={calculated}
              prevDataCalculated={prevDataCalculated}
            />
          </PDFViewer>
        </>
      )}
    </div>
  );
};;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh",
    backgroundColor: "#f5f5f5",
    padding: 20,
  },
  heading: {
    marginBottom: 20,
    fontSize: "24px",
    fontWeight: "bold",
    color: "#333",
  },
  viewer: {
    width: "80%",
    height: "90%",
    border: "1px solid #ccc",
    borderRadius: "8px",
  },
};

export default SandboxPage;
